var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_35000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33984 515.848H854.054L853.527 633.058L757.26 585.576L647.773 638.702L560.5 593.213L454.186 665.93L323.278 703.118L239.576 649.992L205.065 602.842L123.743 641.691L103.512 593.213L28.1408 572.295L4.33984 515.848Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.355 639.357H213.679V764.424H268.355V639.357Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.576 608.389V765.439H269.378L269.608 594.946",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.576 608.389V765.439H269.378L269.608 594.946",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.939 610.692L279.2 593.197L203.939 610.692Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.939 610.692L279.2 593.197",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.015 759.117L163.209 755.575L212.793 752.697",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.015 759.117L163.209 755.575L212.793 752.697",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.015 742.346L162.987 739.468L212.793 735.926",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.015 742.346L162.987 739.468L212.793 735.926",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.019 734.874L317.495 738.858L268.99 742.622",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.019 734.874L317.495 738.858L268.99 742.622",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.354 751.979L317.61 756.849L269.161 759.949",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.354 751.979L317.61 756.849L269.161 759.949",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.461 600.342V512.684H268.078V588.15",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.461 600.342V512.684H268.078V588.15",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.705 513.564L212.623 530.117L267.657 521.235V513.398L212.705 513.564Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.173 544.892V529.286L258.614 523.226V539.081L222.173 544.892Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.146 544.836L221.758 598.074L222.146 544.836Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.146 544.836L221.758 598.074",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.614 538.527V590.105V538.527Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.614 538.527V590.105",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5 716.466H213.627V728.946H232.5V716.466Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.207 728.258L213.706 716.343L232.207 728.258Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.207 728.258L213.706 716.343",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.877 728.124L232.049 716.867L213.877 728.124Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.877 728.124L232.049 716.867",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.479 705.101H260.108H250.479Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.479 705.101H260.108",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.361 706.429V693.971V706.429Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.361 706.429V693.971",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.415 595.555L231.501 543.993L250.206 541.115L250.369 591.239L231.415 595.555Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.364 452.484H4V467.636H579.364V452.484Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.823 264.485H235.787V335.707H247.823V264.485Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.977 333.881H232.715V390.328H250.977V333.881Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.433 388.336H221.924V409.919H262.433V388.336Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.873 497.355H202.832V507.316H277.873V497.355Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.691 505.379H198.681V514.344H281.691V505.379Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.066 436.314H212.627V497.243H271.066V436.314Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.971 441.516H203.994V445.002H209.971V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.604 441.516H212.627V445.002H218.604V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.237 441.516H221.26V445.002H227.237V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87 441.516H229.893V445.002H235.87V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.503 441.516H238.526V445.002H244.503V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.136 441.516H247.159V445.002H253.136V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.769 441.516H255.792V445.002H261.769V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.402 441.516H264.425V445.002H270.402V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.035 441.516H273.058V445.002H279.035V441.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.513 406.708H198.681V441.959H284.513V406.708Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.971 403.498H203.994V406.984H209.971V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.604 403.498H212.627V406.984H218.604V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.237 403.498H221.26V406.984H227.237V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87 403.498H229.893V406.984H235.87V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.503 403.498H238.526V406.984H244.503V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.136 403.498H247.159V406.984H253.136V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.769 403.498H255.792V406.984H261.769V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.402 403.498H264.425V406.984H270.402V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.035 403.498H273.058V406.984H279.035V403.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.265 436.481C243.511 436.481 245.332 434.66 245.332 432.414C245.332 430.168 243.511 428.347 241.265 428.347C239.019 428.347 237.198 430.168 237.198 432.414C237.198 434.66 239.019 436.481 241.265 436.481Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.681 424.03H284.513H198.681Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.681 424.03H284.513",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.38 295.531L787.308 281.834L260.097 281.641L260 295.807L772.38 295.531Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.368 279.344H499.509V299.1H514.368V279.344Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.051 274.861H503.991V302.835H510.051V274.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.934 279.344H567.493V299.1H603.934V279.344Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.977 270.572H232.715V307.871H250.977V270.572Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.089 280.147L246.827 288.226L251.088 297.135L259.72 297.301L259.886 280.201L251.089 280.147Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.313 449.828H136.756V470.681H186.313V449.828Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.727 449.828H287.17V470.681H336.727V449.828Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.795 380.772C252.431 380.772 261.053 372.15 261.053 361.514C261.053 350.878 252.431 342.256 241.795 342.256C231.159 342.256 222.537 350.878 222.537 361.514C222.537 372.15 231.159 380.772 241.795 380.772Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.795 371.641C246.838 371.641 250.926 367.553 250.926 362.51C250.926 357.467 246.838 353.379 241.795 353.379C236.752 353.379 232.664 357.467 232.664 362.51C232.664 367.553 236.752 371.641 241.795 371.641Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.945 352.549C247.87 352.549 249.431 350.988 249.431 349.063C249.431 347.138 247.87 345.577 245.945 345.577C244.02 345.577 242.459 347.138 242.459 349.063C242.459 350.988 244.02 352.549 245.945 352.549Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.752 357.861C254.677 357.861 256.238 356.3 256.238 354.375C256.238 352.45 254.677 350.889 252.752 350.889C250.827 350.889 249.266 352.45 249.266 354.375C249.266 356.3 250.827 357.861 252.752 357.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.408 365.498C257.334 365.498 258.894 363.937 258.894 362.012C258.894 360.087 257.334 358.526 255.408 358.526C253.483 358.526 251.922 360.087 251.922 362.012C251.922 363.937 253.483 365.498 255.408 365.498Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.752 373.135C254.677 373.135 256.238 371.574 256.238 369.649C256.238 367.724 254.677 366.163 252.752 366.163C250.827 366.163 249.266 367.724 249.266 369.649C249.266 371.574 250.827 373.135 252.752 373.135Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.277 378.282C248.202 378.282 249.763 376.721 249.763 374.796C249.763 372.871 248.202 371.31 246.277 371.31C244.352 371.31 242.791 372.871 242.791 374.796C242.791 376.721 244.352 378.282 246.277 378.282Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.478 378.282C239.403 378.282 240.964 376.721 240.964 374.796C240.964 372.871 239.403 371.31 237.478 371.31C235.553 371.31 233.992 372.871 233.992 374.796C233.992 376.721 235.553 378.282 237.478 378.282Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.837 373.467C232.762 373.467 234.323 371.906 234.323 369.981C234.323 368.056 232.762 366.495 230.837 366.495C228.912 366.495 227.351 368.056 227.351 369.981C227.351 371.906 228.912 373.467 230.837 373.467Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.015 365.664C229.941 365.664 231.501 364.103 231.501 362.178C231.501 360.253 229.941 358.692 228.015 358.692C226.09 358.692 224.529 360.253 224.529 362.178C224.529 364.103 226.09 365.664 228.015 365.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.505 357.695C232.43 357.695 233.991 356.134 233.991 354.209C233.991 352.284 232.43 350.723 230.505 350.723C228.58 350.723 227.019 352.284 227.019 354.209C227.019 356.134 228.58 357.695 230.505 357.695Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.478 352.549C239.403 352.549 240.964 350.988 240.964 349.063C240.964 347.138 239.403 345.577 237.478 345.577C235.553 345.577 233.992 347.138 233.992 349.063C233.992 350.988 235.553 352.549 237.478 352.549Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.818 408.414C268.225 408.414 289.632 387.007 289.632 360.6C289.632 334.193 268.225 312.786 241.818 312.786C215.411 312.786 194.004 334.193 194.004 360.6C194.004 387.007 215.411 408.414 241.818 408.414Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.583 235.166C253.503 235.166 263.166 225.503 263.166 213.583C263.166 201.663 253.503 192 241.583 192C229.663 192 220 201.663 220 213.583C220 225.503 229.663 235.166 241.583 235.166Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.648 233.282C252.529 233.282 261.349 224.461 261.349 213.581C261.349 202.7 252.529 193.88 241.648 193.88C230.768 193.88 221.947 202.7 221.947 213.581C221.947 224.461 230.768 233.282 241.648 233.282Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86 226.117L229.921 223.157L225.86 226.117Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86 226.117L229.921 223.157",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.624 225.817L252.904 223.169L256.624 225.817Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.624 225.817L252.904 223.169",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.889 212.856L260.894 212.857L257.889 212.856Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.889 212.856L260.894 212.857",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.009 208.869L225.685 209.404L223.009 208.869Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.009 208.869L225.685 209.404",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.728 202.414L227.947 204.396L225.728 202.414Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.728 202.414L227.947 204.396",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.015 197.695L231.799 200.485L230.015 197.695Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.015 197.695L231.799 200.485",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.614 195.01L236.686 198.417L235.614 195.01Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.614 195.01L236.686 198.417",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.792 194.088V197.552V194.088Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.792 194.088V197.552",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.788 194.866L246.509 197.931L247.788 194.866Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.788 194.866L246.509 197.931",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.283 197.242L251.209 199.871L253.283 197.242Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.283 197.242L251.209 199.871",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.156 201.947L255.064 203.587L257.156 201.947Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.156 201.947L255.064 203.587",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.06 207.274L257.695 208.35L260.06 207.274Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.06 207.274L257.695 208.35",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.206 219.033L223.453 220.353L226.206 219.033Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.206 219.033L223.453 220.353",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.761 212.998L248.92 200.597L241.761 212.998Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.761 212.998L248.92 200.597",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.701 216.464C243.229 216.464 244.468 215.225 244.468 213.697C244.468 212.169 243.229 210.93 241.701 210.93C240.173 210.93 238.934 212.169 238.934 213.697C238.934 215.225 240.173 216.464 241.701 216.464Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.612 214.245L225.23 214.254L222.612 214.245Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.612 214.245L225.23 214.254",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.763 313.756L241.102 361.906L232.763 313.756Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.763 313.756L241.102 361.906",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.874 361.574L205.479 388.371L240.874 361.574Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.874 361.574L205.479 388.371",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.045 360.553L285.884 378.259L241.045 360.553Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.045 360.553L285.884 378.259",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.688 479.091C172.324 479.091 180.946 470.469 180.946 459.833C180.946 449.197 172.324 440.575 161.688 440.575C151.052 440.575 142.43 449.197 142.43 459.833C142.43 470.469 151.052 479.091 161.688 479.091Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.688 469.96C166.731 469.96 170.819 465.872 170.819 460.829C170.819 455.786 166.731 451.698 161.688 451.698C156.645 451.698 152.557 455.786 152.557 460.829C152.557 465.872 156.645 469.96 161.688 469.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.838 450.868C167.763 450.868 169.324 449.307 169.324 447.382C169.324 445.457 167.763 443.896 165.838 443.896C163.913 443.896 162.352 445.457 162.352 447.382C162.352 449.307 163.913 450.868 165.838 450.868Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.645 456.18C174.57 456.18 176.131 454.619 176.131 452.694C176.131 450.769 174.57 449.208 172.645 449.208C170.72 449.208 169.159 450.769 169.159 452.694C169.159 454.619 170.72 456.18 172.645 456.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.301 463.817C177.227 463.817 178.787 462.256 178.787 460.331C178.787 458.406 177.227 456.845 175.301 456.845C173.376 456.845 171.815 458.406 171.815 460.331C171.815 462.256 173.376 463.817 175.301 463.817Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.645 471.454C174.57 471.454 176.131 469.893 176.131 467.968C176.131 466.043 174.57 464.482 172.645 464.482C170.72 464.482 169.159 466.043 169.159 467.968C169.159 469.893 170.72 471.454 172.645 471.454Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.17 476.601C168.095 476.601 169.656 475.04 169.656 473.115C169.656 471.19 168.095 469.629 166.17 469.629C164.245 469.629 162.684 471.19 162.684 473.115C162.684 475.04 164.245 476.601 166.17 476.601Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.371 476.601C159.297 476.601 160.857 475.04 160.857 473.115C160.857 471.19 159.297 469.629 157.371 469.629C155.446 469.629 153.885 471.19 153.885 473.115C153.885 475.04 155.446 476.601 157.371 476.601Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73 471.786C152.655 471.786 154.216 470.225 154.216 468.3C154.216 466.375 152.655 464.814 150.73 464.814C148.805 464.814 147.244 466.375 147.244 468.3C147.244 470.225 148.805 471.786 150.73 471.786Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.908 463.983C149.834 463.983 151.394 462.422 151.394 460.497C151.394 458.572 149.834 457.011 147.908 457.011C145.983 457.011 144.422 458.572 144.422 460.497C144.422 462.422 145.983 463.983 147.908 463.983Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.398 456.014C152.323 456.014 153.884 454.453 153.884 452.528C153.884 450.603 152.323 449.042 150.398 449.042C148.473 449.042 146.912 450.603 146.912 452.528C146.912 454.453 148.473 456.014 150.398 456.014Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.371 450.868C159.297 450.868 160.857 449.307 160.857 447.382C160.857 445.457 159.297 443.896 157.371 443.896C155.446 443.896 153.885 445.457 153.885 447.382C153.885 449.307 155.446 450.868 157.371 450.868Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.646 488.168C177.539 488.168 190.422 475.285 190.422 459.392C190.422 443.499 177.539 430.616 161.646 430.616C145.754 430.616 132.87 443.499 132.87 459.392C132.87 475.285 145.754 488.168 161.646 488.168Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.493 429.41L161.899 461.579L156.493 429.41Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.493 429.41L161.899 461.579",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.357 459.784L140.763 479.494L162.357 459.784Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.357 459.784L140.763 479.494",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.087 460.069L186.599 472.06L162.087 460.069Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.087 460.069L186.599 472.06",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.607 479.257C321.243 479.257 329.865 470.635 329.865 459.999C329.865 449.363 321.243 440.741 310.607 440.741C299.971 440.741 291.349 449.363 291.349 459.999C291.349 470.635 299.971 479.257 310.607 479.257Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.607 470.126C315.65 470.126 319.738 466.038 319.738 460.995C319.738 455.952 315.65 451.864 310.607 451.864C305.564 451.864 301.476 455.952 301.476 460.995C301.476 466.038 305.564 470.126 310.607 470.126Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.757 451.034C316.682 451.034 318.243 449.473 318.243 447.548C318.243 445.623 316.682 444.062 314.757 444.062C312.832 444.062 311.271 445.623 311.271 447.548C311.271 449.473 312.832 451.034 314.757 451.034Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.564 456.346C323.489 456.346 325.05 454.785 325.05 452.86C325.05 450.935 323.489 449.374 321.564 449.374C319.639 449.374 318.078 450.935 318.078 452.86C318.078 454.785 319.639 456.346 321.564 456.346Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.221 463.983C326.147 463.983 327.707 462.422 327.707 460.497C327.707 458.572 326.147 457.011 324.221 457.011C322.296 457.011 320.735 458.572 320.735 460.497C320.735 462.422 322.296 463.983 324.221 463.983Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.564 471.62C323.489 471.62 325.05 470.059 325.05 468.134C325.05 466.209 323.489 464.648 321.564 464.648C319.639 464.648 318.078 466.209 318.078 468.134C318.078 470.059 319.639 471.62 321.564 471.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09 476.767C317.015 476.767 318.576 475.206 318.576 473.281C318.576 471.356 317.015 469.795 315.09 469.795C313.165 469.795 311.604 471.356 311.604 473.281C311.604 475.206 313.165 476.767 315.09 476.767Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.29 476.767C308.215 476.767 309.776 475.206 309.776 473.281C309.776 471.356 308.215 469.795 306.29 469.795C304.365 469.795 302.804 471.356 302.804 473.281C302.804 475.206 304.365 476.767 306.29 476.767Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.65 471.952C301.575 471.952 303.136 470.391 303.136 468.466C303.136 466.541 301.575 464.98 299.65 464.98C297.725 464.98 296.164 466.541 296.164 468.466C296.164 470.391 297.725 471.952 299.65 471.952Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.827 464.149C298.753 464.149 300.313 462.588 300.313 460.663C300.313 458.738 298.753 457.177 296.827 457.177C294.902 457.177 293.341 458.738 293.341 460.663C293.341 462.588 294.902 464.149 296.827 464.149Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.318 456.18C301.243 456.18 302.804 454.619 302.804 452.694C302.804 450.769 301.243 449.208 299.318 449.208C297.393 449.208 295.832 450.769 295.832 452.694C295.832 454.619 297.393 456.18 299.318 456.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.29 451.034C308.215 451.034 309.776 449.473 309.776 447.548C309.776 445.623 308.215 444.062 306.29 444.062C304.365 444.062 302.804 445.623 302.804 447.548C302.804 449.473 304.365 451.034 306.29 451.034Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.566 488.334C326.459 488.334 339.342 475.451 339.342 459.558C339.342 443.665 326.459 430.782 310.566 430.782C294.673 430.782 281.79 443.665 281.79 459.558C281.79 475.451 294.673 488.334 310.566 488.334Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.372 431.031L311.144 461.712L305.372 431.031Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.372 431.031L311.144 461.712",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.801 459.946L289.683 476.818L310.801 459.946Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.801 459.946L289.683 476.818",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.504 460.218L337.919 471.77L310.504 460.218Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.504 460.218L337.919 471.77",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.935 449.799H364.083V470.651H401.935V449.799Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.447 441.639V451.268L383.633 455.003L392.793 451.185V441.652L374.447 441.639Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.487 449.798H435.248V470.65H459.487V449.798Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.147 447.917H445.653V472.532H461.147V447.917Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.147 447.142H451.74V473.418H461.147V447.142Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.147 445.371H453.512V474.967H461.147V445.371Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.574 278.046H728.285V282.805H739.574V278.046Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.944 278.046H746.655V282.805H757.944V278.046Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.583 269.52H730.056V279.376H737.583V269.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.174 269.52H748.647V279.15H756.174V269.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.716 265.097H726.293V271.296H759.716V265.097Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.944 249.16H728.285V266.2H757.944V249.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.67 249.159C755.59 249.159 765.253 239.496 765.253 227.576C765.253 215.656 755.59 205.993 743.67 205.993C731.75 205.993 722.087 215.656 722.087 227.576C722.087 239.496 731.75 249.159 743.67 249.159Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.613 247.331C754.494 247.331 763.314 238.511 763.314 227.63C763.314 216.749 754.494 207.929 743.613 207.929C732.733 207.929 723.912 216.749 723.912 227.63C723.912 238.511 732.733 247.331 743.613 247.331Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.608 220.605H728.948V234.772H758.608V220.605Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.856 260.139H232.594V264.013H250.856V260.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.173 253.578H224.75V259.777H258.173V253.578Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.288 236.787H226.629V253.827H256.288V236.787Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.762 435.948H367.339V442.146H400.762V435.948Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.991 418.681H369.331V435.721H398.991V418.681Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.649 417.353C396.569 417.353 406.232 407.69 406.232 395.77C406.232 383.85 396.569 374.187 384.649 374.187C372.729 374.187 363.066 383.85 363.066 395.77C363.066 407.69 372.729 417.353 384.649 417.353Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.714 415.469C395.595 415.469 404.415 406.648 404.415 395.768C404.415 384.887 395.595 376.067 384.714 376.067C373.834 376.067 365.013 384.887 365.013 395.768C365.013 406.648 373.834 415.469 384.714 415.469Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.926 408.304L372.987 405.344L368.926 408.304Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.926 408.304L372.987 405.344",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.69 408.004L395.97 405.356L399.69 408.004Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.69 408.004L395.97 405.356",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.955 395.043L403.96 395.044L400.955 395.043Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.955 395.043L403.96 395.044",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.075 391.056L368.751 391.591L366.075 391.056Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.075 391.056L368.751 391.591",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.794 384.601L371.013 386.583L368.794 384.601Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.794 384.601L371.013 386.583",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.081 379.882L374.865 382.672L373.081 379.882Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.081 379.882L374.865 382.672",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68 377.197L379.752 380.604L378.68 377.197Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68 377.197L379.752 380.604",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.858 376.275V379.739V376.275Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.858 376.275V379.739",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.854 377.053L389.575 380.118L390.854 377.053Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.854 377.053L389.575 380.118",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.349 379.429L394.275 382.058L396.349 379.429Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.349 379.429L394.275 382.058",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.222 384.134L398.13 385.774L400.222 384.134Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.222 384.134L398.13 385.774",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.126 389.461L400.761 390.537L403.126 389.461Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.126 389.461L400.761 390.537",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.272 401.22L366.519 402.54L369.272 401.22Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.272 401.22L366.519 402.54",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.827 395.185L391.986 382.784L384.827 395.185Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.827 395.185L391.986 382.784",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.767 398.651C386.295 398.651 387.534 397.412 387.534 395.884C387.534 394.356 386.295 393.117 384.767 393.117C383.239 393.117 382 394.356 382 395.884C382 397.412 383.239 398.651 384.767 398.651Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.544 400.573L403.02 401.437L400.544 400.573Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.544 400.573L403.02 401.437",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.83 390.94C604.009 420.727 590.539 457.47 578.918 466.534L577.59 467.863C562.734 486.113 537.316 478.972 520.08 470.06",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.186 390.386C566.149 410.322 576.041 417.391 586.002 439.749",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.128 316.342C575.778 306.137 566.038 299.796 553.242 296.309L582.128 316.342Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.128 316.342C575.778 306.137 566.038 299.796 553.242 296.309",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.703 304.278H580.551V512.134H591.703V304.278Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.362 504.83H578.89V515.455H593.362V504.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.895 451.371H574.436V470.131H584.895V451.371Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.529 449.379H578.421V471.792H593.529V449.379Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.963 298.412H576.539V308.317H595.963V298.412Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.19 315.788H549.035V391.493H623.19V315.788Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.206 318.888H552.576V388.173H619.206V318.888Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.442 306.713H601.07V315.568H619.442V306.713Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.68 208.594H604.833V306.711H615.68V208.594Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.427 179V229V179Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.427 179V229",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 183V225V183Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 183V225",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 187V221V187Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 187V221",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639 191V217V191Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639 191V217",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 195V213V195Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 195V213",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 199V209V199Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 199V209",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 204H649",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.793 762.658L232.537 605.402L251.243 600.297L251.069 762.74L233.793 762.658Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.99996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.795 601.416L279.172 584.372L204.795 601.416Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.795 601.416L279.172 584.372",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.933 715.382H250.966V727.863H269.933V715.382Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.678 396.432L368.296 396.441L365.678 396.432Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.678 396.432L368.296 396.441",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.287 727.146L250.788 715.9L269.287 727.146Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.287 727.146L250.788 715.9",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.957 728.045L270.135 715.444L250.957 728.045Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.957 728.045L270.135 715.444",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 624.524H260.629H251Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 624.524H260.629",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 644.313H260.629H251Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 644.313H260.629",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 663.739H260.629H251Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 663.739H260.629",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 683.852H260.629H251Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 683.852H260.629",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 624.846V612.387V624.846Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 624.846V612.387",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 644.971V632.513V644.971Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 644.971V632.513",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 664.397V651.939V664.397Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 664.397V651.939",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 684.509V672.05V684.509Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 684.509V672.05",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.412 728.65H214.135V764.456H269.412V728.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34 726.977H233.738V729.348H250.34V726.977Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.93 449.775H494.691V470.628H518.93V449.775Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.041 445.349H511.405V474.944H519.041V445.349Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 199,
    width: 16,
    height: 10,
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_35000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLift);
export default __webpack_public_path__ + "static/media/gas-lift.b3173428980aaf5eff1c237ffd284804.svg";
export { ForwardRef as ReactComponent };